import { HashLink as Link } from "react-router-hash-link";
import blogdata from "../data/blog-data";
import scrollToTop from "../components/scrolltoTop";
import TacForm from "../components/form";
import React, { Component } from "react";

export default class BlogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        message: "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  render() {
    const { formData } = this.state;

    const fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        required: true,
        autoComplete: "name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        autoComplete: "email",
      },
    ];

    // Find the featured blog (based on a flag or just first in the array)
    const featuredBlog = blogdata.find((blog) => blog.featured) || blogdata[0];

    // Get the rest of the blogs, excluding the featured
    const otherBlogs = blogdata.filter((blog) => blog.id !== featuredBlog.id);

    return (
      <>
        <div className="blog-landing-container">
          <img
            className="big-leaves"
            src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/bigLeaves.webp"
            alt=""
          />
          <img
            src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/rightSmallLeaves.webp"
            className="right-small-leaves small-leaves leaves"
            alt="leaves"
          />
          <div className="featured-blog-container">
            <h1>whats new</h1>

            <>
              <img
                src={featuredBlog.img}
                alt=""
                className="fblogimg"
                id="featuredid"
              />
              <div className="blog-info">
                <h2>{featuredBlog.title}</h2>
                <div className="blog-details">
                  <div className="author-details">
                    <img
                      src={featuredBlog.authorimg}
                      alt=""
                      className="author-img"
                    />
                    <span>{featuredBlog.author}</span>
                  </div>
                  <span>{featuredBlog.date}</span>
                </div>
                <p>
                  {featuredBlog.intro}{" "}
                  <Link to={`/blog/${featuredBlog.slug}`} onClick={scrollToTop}>
                    Read more...
                  </Link>
                </p>
              </div>{" "}
            </>
          </div>
          <div className="other-blogs-container">
            <h1>other blogs</h1>
            <div className="blogs-container">
              {otherBlogs.reverse().map((blog) => (
                <div className="blog" id={`blog${blog.slug}`}>
                  <img className="oblogimg" src={blog.img} alt="" />
                  <div className="blog-info">
                    <h2>{blog.title}</h2>
                    <div className="blog-details">
                      <div className="author-details">
                        <img
                          src={blog.authorimg}
                          className="author-img"
                          alt="brian"
                        />
                        <span>{blog.author}</span>
                      </div>
                      <span>{blog.date}</span>
                    </div>
                    <p>
                      {blog.intro}
                      <span> </span>
                      <Link to={`/blog/${blog.slug}`} onClick={scrollToTop}>
                        Read more...
                      </Link>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="form-holder">
            <TacForm
              fields={fields}
              formid="Mailing"
              first="Join our mailing list"
              second="Be the first to know about each new post!"
              third=""
              formData={formData}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </>
    );
  }
}
